<template>
  <div class="quotation-kpi">
    <div class="header row">
      <div class="column small-6 medium-6 large-6">
        <p class="title">{{ $t('company.performance.quotationKPI') }}</p>
        <span class="item-title">{{ $t('company.performance.nonTender') }}:</span>
        <span class="percent">{{ nonCompetitiveCount }}</span>
      </div>
      <div class="detail-item column small-6 medium-6 large-6">
        <div class="item-title">{{ $t('company.performance.accumulatedPoAmount') }}:</div>
        <div><span class="percent po-amount">{{ POAmount | formatCurrency({withSpace:true}) }}</span></div>
      </div>
    </div>
    <div class="contant">
      <div class="conditions-group">
        <div
          class="condition"
          v-for="item in conditions"
          :key="item.label"
        >
          <input
            type="checkbox"
            :value="item.value"
            v-model="chooseConditions"
          >
          <label>{{ item.label }}</label>
        </div>
      </div>
      <div class="chart-detail">
        <div class="center-digital">
          <div class="digital">{{ totalInvited }}</div>
          <div class="text">{{ $t('company.performance.invitations') }}</div>
        </div>
        <div class="chart-contant">
          <div id="KPI-chart" />
          <div class="digital">
            <div><i class="quotedDot" /><span>{{ $t('company.performance.quoted') }}</span><span>{{ totalQuotePercent + `%  [${totalQuote}]` }}</span></div>
            <div><i class="declinedDot" /><span>{{ $t('company.performance.declined') }}</span><span>{{ totalDeclinedPercent + `%  [${totalDeclined}]` }}</span></div>
            <div><i class="noshowDot" /><span>{{ $t('company.performance.noShow') }}</span><span>{{ totalNoShowPercent + `%  [${totalNoShow}]` }}</span></div>
          </div>
        </div>
        <div class="detail">
          <div class="competitive">
            <div class="detail-item">
              <span class="title">{{ $t('company.performance.tenderQwarded') }}:</span>
              <span class="percent">{{ formatQUotation(totalAwarded) }}</span><span>[<i>{{ $t('xxOfxx', [totalAwarded, invitationDivided]) }}</i>]</span>
            </div>
            <div class="detail-item">
              <span class="title">{{ $t('company.performance.differenceToAwarded') }}:</span>
              <span class="percent">{{ differenceToAwarded }}</span>
            </div>
            <div class="detail-item">
              <span class="title">{{ $t('company.performance.highestQuotation') }}:</span>
              <span class="percent">{{ formatQUotation(highestQuotation) }}</span><span> [<i>{{ $t('xxOfxx', [highestQuotation, invitationDivided]) }}</i>]</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import moment from 'moment'
import G2 from '@antv/g2'

import { calcTotalQuoteByStatus, getFee, getQuotationNumber, calcPOAmount } from '../../performance/performanceUtils'
import { getPurchase } from '@/api/projects/util'
import { View } from '@antv/data-set'
import { vendorBidStatus } from '@/utils/locale'

export default {
  name: 'QuotationKpi',
  props: {
    tendersData: {
      style: Array,
      default: () => [],
    },
    companyId: {
      style: String,
      default: '',
    },
    startDay: {
      type: [Date, String],
      default: '',
    },
    endDay: {
      type: [Date, String],
      default: '',
    },
    projects: {
      type: Array,
      default: () => [],
    },
    purchaseAmounts: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      conditions: [
        {
          label: 'ITQ',
          value: 2,
        },
        {
          label: 'Tender',
          value: 4,
        },
      ],
      chooseConditions: [2, 4],
      chart: '',
      dv: '',
      filteredTender: [],
      totalInvited: 0,
      totalQuote: 0,
      totalDeclined: 0,
      totalNoShow: 0,
      invitationDivided: 0,
      totalAwarded: 0,
      highestQuotation: 0,
      lowestQuotation: 0,
      totalQuotePercent: 0,
      totalDeclinedPercent: 0,
      totalNoShowPercent: 0,
      drawData: [
        { item: 'EMPTY', count: 100 },
      ],
      differenceToAwarded: '--',
      nonCompetitiveCount: 0,
      POAmount: 0,
    }
  },
  methods: {
    draw () {
      this.dv.source(this.drawData).transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent',
      })
      this.chart.source(this.dv)
      this.chart.coord('theta', {
        radius: 0.75,
        innerRadius: 0.6,
      })

      this.chart.intervalStack()
        .position('percent')
        .color('item', (type, value) => {
          let ret = '#ececf5'
          switch (type) {
            case 'Quoted':
              ret = '#7194ac'
              break
            case 'Declined':
              ret = '#b1c3cf'
              break
            case 'NoShow':
              ret = '#e5e9eb'
              break
            default:
              break
          }
          return ret
        })
        .size(20)
        .select(false)
      this.chart.legend(false)
      this.chart.tooltip(false)
      this.chart.render()
    },
    setDrawData (quoted, declined, noshow) {
      this.drawData = [
        { item: 'Quoted', count: quoted },
        { item: 'Declined', count: declined },
        { item: 'NoShow', count: noshow },
      ]
    },
    changeData () {
      if (!this.totalQuote && !this.totalDeclined && !this.totalNoShow) {
        this.drawData = [{ item: 'EMPTY', count: 100 }]
      } else {
        this.setDrawData(this.totalQuote, this.totalDeclined, this.totalNoShow)
      }
      this.dv.source(this.drawData).transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent',
      })
      this.chart.changeData(this.dv)
      this.chart.repaint()
    },
    parseData (data) {
      this.itq = []
      this.tenders = []
      let ret = []

      data.forEach(item => {
        lodash.get(item, 'general.tenderType') === 'TENDER' ? this.tenders.push(item) : this.itq.push(item)
      })
      if (this.chooseConditions.indexOf(2) !== -1) {
        ret = ret.concat(this.itq)
      }
      if (this.chooseConditions.indexOf(4) !== -1) {
        ret = ret.concat(this.tenders)
      }
      this.filteredTender = ret
    },
    /* eslint-disable */
    calAllPercentAndGetDrawData() {
      const sum = lodash.sum(this.chooseConditions)
      this.totalInvited = this.filteredTender.length

      switch (sum) {
        case 2:
          this.calcAllTotal(this.itq, this.itq.length)
          break
        case 4:
          this.calcAllTotal(this.tenders, this.tenders.length)
          break
        case 6:
          this.calcAllTotal(this.filteredTender, this.filteredTender.length)
          break
        default:
          this.calcAllTotal([], 0)
          break
      }
    },
    calcAllTotal (selectData, divided) {
      this.totalQuote = selectData.length ? calcTotalQuoteByStatus(selectData, [vendorBidStatus.SUBMITTED], this.companyId) : 0
      this.totalDeclined = selectData.length ? calcTotalQuoteByStatus(selectData, [vendorBidStatus.DECLINED], this.companyId) : 0
      this.totalNoShow = selectData.length ? calcTotalQuoteByStatus(selectData, [vendorBidStatus.INVITED, vendorBidStatus.DRAFT], this.companyId) : 0
      this.totalQuotePercent = selectData.length ? this.calcPercent(this.totalQuote, divided) : 0
      this.totalDeclinedPercent = selectData.length ? this.calcPercent(this.totalDeclined, divided) : 0
      this.totalNoShowPercent = selectData.length ? this.calcPercent(this.totalNoShow, divided) : 0
      const {totalAwarded, highestQuotation, lowestQuotation} = getQuotationNumber(selectData.length ? selectData : [], this.companyId)
      this.totalAwarded = totalAwarded
      this.highestQuotation = highestQuotation
      this.lowestQuotation = lowestQuotation
      this.getDifferenceToAwarded(selectData.length ? selectData : [])
      this.calcNonCompetitiveInfo()
      this.POAmount = calcPOAmount(this.purchaseAmounts, this.tenders)
      this.invitationDivided = divided
    },
    calcNonCompetitiveInfo () {
      let count = 0
      this.projects.map(project => {
        const purchase = getPurchase(project)
        const tender = lodash.get(purchase, 'tenders', -1)
        if (tender !== -1 && !tender.length) {
          count++
        }
      })
      this.nonCompetitiveCount = count
    },
    calcPercent (member, divided) {
      return (member / divided * 100).toFixed(2)
    },
    reCalcAndReDraw (val) {
      this.parseData(val)
      this.calAllPercentAndGetDrawData()
      this.changeData()
    },
    formatQUotation (val) {
      const divided = this.invitationDivided
      return `${(divided ? (val / divided * 100).toFixed(2) : 0)}%`
    },
    getDifferenceToAwarded (selectData) {
      let eachDifference = []
      this.calcDifferenceToAwarded(selectData, eachDifference)
      const len = eachDifference.length
      this.differenceToAwarded = len ? (lodash.sum(eachDifference) / len * 100).toFixed(2) + '%' : '--'
    },
    calcDifferenceToAwarded (selectData, eachDifference) {
      selectData.map(item => {
        const recommendedBidId = lodash.get(item, 'general.analysis.data.recommendedBidId', '')
        let awardedFee = 0
        let selfFee = 0
        item.bids.map(bid => {
          if (bid.id === recommendedBidId && bid.status === vendorBidStatus.SUBMITTED) {
            awardedFee = getFee(bid)
          }
          if (bid.vendorId === this.companyId && bid.status === vendorBidStatus.SUBMITTED) {
            selfFee = getFee(bid)
          }
        })

        if (recommendedBidId && selfFee && awardedFee) {
          eachDifference.push((selfFee - awardedFee) / awardedFee)
        }
      })
    }
  },
  watch: {
    tendersData (val) {
      this.reCalcAndReDraw(val)
    },
    chooseConditions () {
      this.reCalcAndReDraw(this.tendersData)
    },
    projects () {
      this.calcNonCompetitiveInfo()
    },
    purchaseAmounts (val) {
      this.POAmount = calcPOAmount(val, this.tendersData)
    }
  },
  computed: {
    startDate () {
      return moment(this.startDay).format('DD MMM YYYY')
    },
    endDate () {
      return moment(this.endDay).format('DD MMM YYYY')
    }
  },
  mounted () {
    // To turn event tracking monitoring
    // https://antv.vision/old-site/g2/api/index.html
    G2.track(false)
    this.dv = new View()
    this.chart = new G2.Chart({
      container: 'KPI-chart',
      height: 200,
      width: 300,
      animate: false,
      padding: 0
    })
    this.dv = new View()
    this.draw()
  },
  destroyed () {
    this.chart && this.chart.destroy()
  }
}
</script>

<style lang="scss" scoped>
.quotation-kpi{
  margin-top: 20px;
  padding: 20px;
  color: #0C3A58;
  .header {
    padding-bottom: 10px;
    .title{
      height: 22px;
      font-family: Verdana;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;;
    }
    .item-title {
      font-size: 14px;
      color: #1A557D;
    }
    .percent {
      font-weight: bold;
      font-size: 18px;
    }
    .po-amount {
      font-size: 24px;
    }
    .detail-item {
      text-align: right;
      .item-title {
        font-size: 12px;
        font-weight: bold;
        color: #4B6888;
      }
    }
  }
  .conditions-group{
    padding: 15px 0;
    border-bottom: 1px solid #ccc;
    .condition{
      display: inline-block;
      margin-left: 20px;
      input{
        vertical-align: sub;
      }
      label {
        color: #004467;
      }
    }
    .condition:first-child{
      margin-left: 0;
    }
  }

  .contant {
    display: flex;
    padding: 0 20px 10px 20px;
    flex-direction: column;
    background: white;
    #KPI-chart {
      width: 300px;
      text-align: center;
    }
   .chart-detail {
      position: relative;
      display: flex;
      .center-digital {
        position: absolute;
        width: 300px;
        text-align: center;
        top: 70px;
        .digital {
          height: 34px;
          font-family: Verdana;
          font-size: 28px;
          font-weight: bold;
          text-align: center;
          color: #1a557d;
        }
        .text {
          height: 15px;
          font-family: Verdana;
          font-size: 12px;
          text-align: center;
          color: #0c3a58;
        }
      }
      .chart-contant {
        width: 290px;
        margin-right: 10px;
        background: #ffffff;
        flex-direction: column;
        .chart {
          flex: 3;
        }
        .digital {
          flex: 2;
          .dot {
            height: 11px;
            width: 11px;
            display: inline-block;
            border-radius: 50%;
            margin-right: 20px;
          }
          .quotedDot {
            @extend .dot;
            background-color: #7194ac;
          }
          .declinedDot {
            @extend .dot;
            background-color: #b1c3cf;
          }
          .noshowDot{
            @extend .dot;
            background-color: #e5e9eb;
          }
          div {
            text-align: left;
            padding-left: 50px;
            span {
              display: inline-block;
            }
            span:nth-child(2) {
              width: 70px;
              color: #717171;
            }
            span:nth-child(3) {
              margin-left: 30px;
            }
          }
        }
      }
      .details {
        flex: 5;
      }
      .detail {
        width: calc(100% - 300px);
        display: flex;
        .competitive {
          flex: 1;
          padding-top: 24px;
          .detail-item {
            background: #F2F6F8;
            padding: 25px 18px;
            margin-bottom: 10px;
          }
        }
        .detail-item {
          margin-bottom: 30px;
          padding: 15px;
          background: #ffffff;
          .title {
              font-family: Verdana;
              font-size: 14px;
              text-align: left;
              color: #4B6888;
              line-height: 14px;
              margin-bottom: 7px;
          }
          .percent {
            font-weight: bold;
          }
          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
